{
  "main": {
    "title": "Pilot Logbook",
    "nazaj": "Back"
  },
  "navs": {
    "vnos": "Entry",
    "dnevnik": "Logbook"
  },
  "labels": {
    "datum": "Date:",
    "casO": "Departure time:",
    "krajV": "Takeoff location: LJAJ",
    "casP": "Arrival time:",
    "krajP": "Landing location: LJAJ",
    "model": "Model, variant",
    "reg": "Aircraft registration: S5-XYZ",
    "ime": "Pilot-in-command name",
    "posadka": "Single crew / Multi crew:",
    "posadkaVec": "MULTI",
    "skupniCas": "Total time of flight:",
    "stPristankovDN": "Number of landings (Day / Night):",
    "dan": "Day",
    "noc": "Night",
    "stPristankov": "Number of landings:",
    "op": "Operating conditions:",
    "opD": "Day",
    "opN": "Night",
    "vlogaP": "Pilot role:",
    "fstd": "Total time on FSTD:",
    "opomba": "Note"
  },
  "buttons": {
    "vnesiZapis": "Submit entry"
  },
  "obvestila": {
    "zapisDodan": "Record successfully added.",
    "napakaVnosa": "Data entry error.",
    "napakaInputa": "All data must be filled in to add a record. Please check that all fields are completed!",
    "napakaBranja": "Error reading data."
  }
}